import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDOrders_FormQR_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDOrders_FormQR_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetMyDetail: any[];
  GetMyDetail_dummy: any[];
  SelectSTDOrders: any[];
  SelectSTDOrders_dummy: any[];
  SelectStdboxesForBoxid: any[];
  SelectStdboxesForBoxid_dummy: any[];
  GetAllCustomers: any[];
  GetAllCustomers_dummy: any[];
  GetSapInfos: any[];
  GetSapInfos_dummy: any[];
  GetOrdersWithFirstStatus: any[];
  GetOrdersWithFirstStatus_dummy: any[];
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  GetBoxDetailWithId: any[];
  GetBoxDetailWithId_dummy: any[];
  OrderBoxCheck: any[];
  OrderBoxCheck_dummy: any[];
  OrderWaitingBoxCheck: any[];
  OrderWaitingBoxCheck_dummy: any[];
  STDOrdersTaslakSave: number;
  STDOrdersTaslakSave_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  Notify: boolean;
  Notify_dummy: boolean;
  DeleteStdOrdersTaslakWithId: number;
  DeleteStdOrdersTaslakWithId_dummy: number;
  CreateLogsForUser: string;
  CreateLogsForUser_dummy: string;
  CreateOrdersPerStation: any;
  CreateOrdersPerStation_dummy: any;
  NewFunctionName: number;
  NewFunctionName_dummy: number;
  TaslaktToOrders: number;
  TaslaktToOrders_dummy: number;
  DeleteTaslakOrdersByUserId: number;
  DeleteTaslakOrdersByUserId_dummy: number;
  isComp43476Visible: "visible" | "hidden";
  isComp653190Visible: "visible" | "hidden";
  isComp284558Visible: "visible" | "hidden";
  isComp173899Visible: "visible" | "hidden";
}

export class STDOrders_FormQR_ScreenBase extends React.PureComponent<
  ISTDOrders_FormQR_ScreenProps,
  any
> {
  stdorders_formqr_67742_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "aa891a24-85f6-4f5f-9a58-5b05018d44b3",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 293125, PropertyName: "value", Value: "Sipariş Oluştur" },
        { Id: 9544, PropertyName: "label", Value: "QR OKUT" },
        { Id: 547110, PropertyName: "title", Value: "Sipariş Bilgileri" },
        {
          Id: 207932,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 143566, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 43476, PropertyName: "value", Value: "Bekliyor" },
        { Id: 653190, PropertyName: "label", Value: "Sipariş Oluştur" },
        { Id: 173899, PropertyName: "label", Value: "Sipariş Oluştur" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdorders_formqr_67742_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetMyDetail: [],
      SelectSTDOrders: [],
      SelectStdboxesForBoxid: [],
      GetAllCustomers: [],
      GetSapInfos: [],
      GetOrdersWithFirstStatus: [],
      ScanBarcode: "",
      GetBoxDetailWithId: [],
      OrderBoxCheck: [],
      OrderWaitingBoxCheck: [],
      DeleteStdOrdersTaslakWithId: 0,
      CreateLogsForUser: "",
      CreateOrdersPerStation: "",
      Notify: false,
      NewFunctionName: 0,
      isComp43476Visible: "hidden",
      isComp653190Visible: "hidden",
      isComp284558Visible: "hidden",
      isComp173899Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdorders_formqr", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDOrders_FormQRPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdorders_formqr", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdorders_formqr", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDOrders_FormQRPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDOrders_FormQRPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormQRPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDOrders_FormQR",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDOrders_FormQRPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderCreate
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDOrders_FormQRPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormQRPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDOrders_FormQRPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      userId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMyDetail = result?.data.getMyDetail;
    stateVars.SelectSTDOrders = result?.data.selectSTDOrders;
    stateVars.SelectStdboxesForBoxid = result?.data.selectStdboxesForBoxid;
    stateVars.GetAllCustomers = result?.data.getAllCustomers;
    stateVars.GetSapInfos = result?.data.getSapInfos;
    stateVars.GetOrdersWithFirstStatus = result?.data.getOrdersWithFirstStatus;

    stateVars.isComp653190Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormQRPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_67742 =
      stateVars.GetOrdersWithFirstStatus ?? this.state.GetOrdersWithFirstStatus;
    stateVars.isComp43476Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdorders_formqr_67742_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp653190Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_666162_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormQRComponent_9544_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ScanBarcode),
        "number"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailWithId !== undefined
            ? stateVars.GetBoxDetailWithId?.length > 0
              ? stateVars.GetBoxDetailWithId[0].id
              : null
            : this.state.GetBoxDetailWithId?.length > 0
            ? this.state.GetBoxDetailWithId[0].id
            : null
        ),
        "Guid"
      ),
      BoxId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailWithId !== undefined
            ? stateVars.GetBoxDetailWithId?.length > 0
              ? stateVars.GetBoxDetailWithId[0].id
              : null
            : this.state.GetBoxDetailWithId?.length > 0
            ? this.state.GetBoxDetailWithId[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_9544_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailWithId = result?.data.getBoxDetailWithId;
    stateVars.OrderBoxCheck = result?.data.orderBoxCheck;
    stateVars.OrderWaitingBoxCheck = result?.data.orderWaitingBoxCheck;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_FormQRComponent_9544_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_9544_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailWithId !== undefined
            ? stateVars.GetBoxDetailWithId?.length > 0
              ? stateVars.GetBoxDetailWithId[0].id
              : null
            : this.state.GetBoxDetailWithId?.length > 0
            ? this.state.GetBoxDetailWithId[0].id
            : null
        ),
        "Guid"
      ),
      CreateDate_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      OrderStatus_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      SapOrderId_0: ReactSystemFunctions.convertToTypeByName(55665, "number"),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_9544_onClick_if2",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDOrdersTaslakSave = result?.data.stdOrdersTaslakSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormQRComponent_9544_onClick_if21_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_9544_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.STDOrders_FormQRPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_9544_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e060e7dd_a6d0_e57d_a58d_363fc9bd49b0_notify",
        this.defaultML,
        "Kutuya ait sipariş mevcut."
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_9544_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.OrderBoxCheck !== undefined
            ? stateVars.OrderBoxCheck?.length > 0
              ? stateVars.OrderBoxCheck[0].result
              : null
            : this.state.OrderBoxCheck?.length > 0
            ? this.state.OrderBoxCheck[0].result
            : null
        ),
        "0"
      ) &&
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.OrderWaitingBoxCheck !== undefined
            ? stateVars.OrderWaitingBoxCheck?.length > 0
              ? stateVars.OrderWaitingBoxCheck[0].result
              : null
            : this.state.OrderWaitingBoxCheck?.length > 0
            ? this.state.OrderWaitingBoxCheck[0].result
            : null
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.STDOrders_FormQRComponent_9544_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDOrders_FormQRComponent_9544_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_785966_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stdorders_formqr_67742_value", "id"),
        "Guid"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_785966_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteStdOrdersTaslakWithId =
      result?.data.deleteStdOrdersTaslakWithId;
    stateVars.GetOrdersWithFirstStatus = result?.data.getOrdersWithFirstStatus;

    stateVars.isComp653190Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithFirstStatus !== undefined
            ? stateVars.GetOrdersWithFirstStatus?.length > 0
              ? stateVars.GetOrdersWithFirstStatus[0].id
              : null
            : this.state.GetOrdersWithFirstStatus?.length > 0
            ? this.state.GetOrdersWithFirstStatus[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormQRComponent_785966_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_785966_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_67742 =
      stateVars.GetOrdersWithFirstStatus ?? this.state.GetOrdersWithFirstStatus;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_653190_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      createdByUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      logCreatedUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "string"
      ),
      sapUsername_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userName
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userName
            : null
        ),
        "string"
      ),
      sapPassword_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userPassword
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userPassword
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_653190_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CreateLogsForUser = result?.data.createLogsForUser;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormQRComponent_653190_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_653190_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4585c49d_4223_c151_aed2_101fcec370bd_notify",
        this.defaultML,
        "Sipariş kaydı oluşturuldu."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_173899_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      userId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "string"
      ),
      sapUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userName
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userName
            : null
        ),
        "string"
      ),
      sapPassword_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userPassword
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userPassword
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_173899_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NewFunctionName = result?.data.newFunctionName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormQRComponent_173899_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_173899_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      createdByUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      logCreatedUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      SapOrderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.NewFunctionName),
        "number"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      userId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_FormQR/STDOrders_FormQRComponent_173899_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CreateLogsForUser = result?.data.createLogsForUser;
    stateVars.TaslaktToOrders = result?.data.taslaktToOrders;
    stateVars.DeleteTaslakOrdersByUserId =
      result?.data.deleteTaslakOrdersByUserId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDOrders_FormQRComponent_173899_onClick_if11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_FormQRComponent_173899_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e7469431_f34f_6ab9_9695_f7b6c30fdceb_notify",
        this.defaultML,
        "Sipariş kaydı oluşturuldu."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_173899_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "bec22681_f62c_39ef_f0a0_12e84cf641fb_notify",
        this.defaultML,
        "SAP isteğinde hata meydana geldi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDOrders_FormQRComponent_173899_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, this.state.NewFunctionName),
        "0"
      )
    ) {
      isErrorOccurred =
        await this.STDOrders_FormQRComponent_173899_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDOrders_FormQRComponent_173899_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDOrders_FormQR"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDOrders_FormQRPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDOrders_FormQRPageInit();
    }
  }
}
